import { render, staticRenderFns } from "./getRecord.vue?vue&type=template&id=08802c36&scoped=true"
import script from "./getRecord.vue?vue&type=script&lang=js"
export * from "./getRecord.vue?vue&type=script&lang=js"
import style0 from "./getRecord.vue?vue&type=style&index=0&id=08802c36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08802c36",
  null
  
)

export default component.exports